(function () {
  if (window.rgFeaturedCollectionCenteredInitialized) return;
  window.rgFeaturedCollectionCenteredInitialized = true;

  var INTERACTION_EVENTS = ['pointerenter', 'mouseenter', 'focusin', 'touchstart', 'mousedown', 'keydown'];

  function getCenteredCarousels() {
    return document.querySelectorAll('carousel-slider[data-rg-featured-centered]');
  }

  function afterLayout(callback) {
    requestAnimationFrame(function () {
      requestAnimationFrame(callback);
    });
  }

  function manuallyLoadImages(container) {
    if (container.dataset.rgFeaturedCenteredImagesLoaded === 'true') return;
    container.dataset.rgFeaturedCenteredImagesLoaded = 'true';

    if (window.theme && typeof window.theme.manuallyLoadImages === 'function') {
      window.theme.manuallyLoadImages(container);
      return;
    }

    container.querySelectorAll('img[data-manual-src]').forEach(function (image) {
      image.src = image.dataset.manualSrc;
      image.removeAttribute('data-manual-src');
      if (image.dataset.manualSrcset) {
        image.srcset = image.dataset.manualSrcset;
        image.removeAttribute('data-manual-srcset');
      }
    });
  }

  function getSmallestSrcsetCandidate(image) {
    var srcset = image.getAttribute('srcset');
    if (!srcset) return image.getAttribute('src');

    var firstCandidate = srcset.split(',')[0].trim();
    if (!firstCandidate) return image.getAttribute('src');

    return firstCandidate.split(/\s+/)[0];
  }

  function deferCloneImages(clone) {
    clone.querySelectorAll('img').forEach(function (image) {
      var src = image.getAttribute('src');
      var srcset = image.getAttribute('srcset');
      var lowImpactSrc = getSmallestSrcsetCandidate(image);

      if (!src && !srcset) return;

      if (src) {
        image.dataset.rgFeaturedCloneSrc = src;
      }
      if (srcset) {
        image.dataset.rgFeaturedCloneSrcset = srcset;
      }
      if (lowImpactSrc) {
        image.setAttribute('src', lowImpactSrc);
      }

      image.removeAttribute('srcset');
      image.setAttribute('loading', 'lazy');
      image.setAttribute('decoding', 'async');
      image.setAttribute('fetchpriority', 'low');
    });
  }

  function restoreCloneImage(image) {
    if (image.dataset.rgFeaturedCloneSrcset) {
      image.setAttribute('srcset', image.dataset.rgFeaturedCloneSrcset);
      image.removeAttribute('data-rg-featured-clone-srcset');
    }

    if (image.dataset.rgFeaturedCloneSrc) {
      image.setAttribute('src', image.dataset.rgFeaturedCloneSrc);
      image.removeAttribute('data-rg-featured-clone-src');
    }
  }

  function restoreCloneImages(container) {
    container.querySelectorAll('img[data-rg-featured-clone-src], img[data-rg-featured-clone-srcset]').forEach(restoreCloneImage);
  }

  function getCenteredScrollLeft(slider, target) {
    var sliderRect = slider.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var currentLeft = slider.scrollLeft;
    var targetCenter = targetRect.left - sliderRect.left + currentLeft + (targetRect.width / 2);
    var scrollLeft = targetCenter - (slider.clientWidth / 2);
    var maxLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);

    return Math.max(0, Math.min(scrollLeft, maxLeft));
  }

  function updateCarouselState(carousel, slider) {
    // Do NOT sync carousel.scrollPos from here. CarouselSlider's drag handler
    // owns that field as a frozen snapshot taken at mousedown; overwriting it
    // every scroll event causes the drag math to amplify geometrically.
    if (typeof carousel.slideSpan === 'number' && carousel.slideSpan > 0) {
      carousel.currentIndex = Math.round(Math.abs(slider.scrollLeft) / carousel.slideSpan) || 0;
    }
    if (typeof carousel.setButtonStates === 'function') {
      carousel.setButtonStates();
    }
  }

  function withoutSmoothScroll(slider, callback) {
    var scrollBehavior = slider.style.scrollBehavior;
    var scrollSnapType = slider.style.scrollSnapType;

    slider.style.scrollBehavior = 'auto';
    slider.style.scrollSnapType = 'none';
    callback();
    slider.style.scrollSnapType = scrollSnapType;
    slider.style.scrollBehavior = scrollBehavior;
  }

  function ensureCarouselReady(carousel) {
    if (typeof carousel.refresh === 'function' && !carousel.hasAttribute('loaded')) {
      carousel.refresh();
    }

    return carousel.querySelector('.slider') && carousel.querySelector('[data-rg-featured-centered-target]');
  }

  function prepareClone(slide, cloneType) {
    var clone = slide.cloneNode(true);

    clone.setAttribute('data-rg-featured-centered-clone', cloneType);
    clone.removeAttribute('data-rg-featured-centered-target');
    clone.querySelectorAll('[id]').forEach(function (element) {
      element.removeAttribute('id');
    });
    clone.querySelectorAll('[data-rg-featured-centered-target]').forEach(function (element) {
      element.removeAttribute('data-rg-featured-centered-target');
    });
    deferCloneImages(clone);

    return clone;
  }

  function getRealSlides(carousel) {
    return Array.from(carousel.querySelectorAll('.slider__item:not([hidden]):not([data-rg-featured-centered-clone])'));
  }

  function setupInfiniteLoop(carousel) {
    if (carousel.dataset.rgFeaturedCenteredLoopReady === 'true') return true;

    var grid = carousel.querySelector('.slider__grid');
    var realSlides = getRealSlides(carousel);

    if (!grid || realSlides.length < 2) return false;

    var beforeFragment = document.createDocumentFragment();
    var afterFragment = document.createDocumentFragment();

    realSlides.forEach(function (slide) {
      beforeFragment.appendChild(prepareClone(slide, 'before'));
      afterFragment.appendChild(prepareClone(slide, 'after'));
    });

    grid.insertBefore(beforeFragment, realSlides[0]);
    grid.appendChild(afterFragment);
    carousel.dataset.rgFeaturedCenteredLoopReady = 'true';

    if (typeof carousel.refresh === 'function') {
      carousel.refresh();
    }

    return true;
  }

  function getLoopMetrics(carousel) {
    var slider = carousel.querySelector('.slider');
    var realSlides = getRealSlides(carousel);
    var firstReal = realSlides[0];
    var lastReal = realSlides[realSlides.length - 1];
    var firstAfterClone = carousel.querySelector('[data-rg-featured-centered-clone="after"]');

    if (!slider || !firstReal || !lastReal || !firstAfterClone) return null;

    var loopSpan = firstAfterClone.offsetLeft - firstReal.offsetLeft;
    if (loopSpan <= 0) return null;

    return {
      slider: slider,
      loopSpan: loopSpan,
      realStart: getCenteredScrollLeft(slider, firstReal),
      realEnd: getCenteredScrollLeft(slider, lastReal),
      slideSpan: typeof carousel.slideSpan === 'number' && carousel.slideSpan > 0 ? carousel.slideSpan : firstReal.clientWidth
    };
  }

  function normalizeInfiniteScroll(carousel) {
    if (carousel.dataset.rgFeaturedCenteredNormalizing === 'true') return;

    var metrics = getLoopMetrics(carousel);
    if (!metrics) return;

    var buffer = metrics.loopSpan / 2;
    var adjustedLeft = metrics.slider.scrollLeft;

    if (adjustedLeft < metrics.realStart - buffer) {
      adjustedLeft += metrics.loopSpan;
    } else if (adjustedLeft > metrics.realEnd + buffer) {
      adjustedLeft -= metrics.loopSpan;
    } else {
      updateCarouselState(carousel, metrics.slider);
      return;
    }

    carousel.dataset.rgFeaturedCenteredNormalizing = 'true';
    withoutSmoothScroll(metrics.slider, function () {
      metrics.slider.scrollLeft = adjustedLeft;
    });
    carousel.dataset.rgFeaturedCenteredNormalizing = 'false';
    updateCarouselState(carousel, metrics.slider);
  }

  function bindInfiniteScroll(carousel) {
    if (carousel.dataset.rgFeaturedCenteredLoopBound === 'true') return;
    var slider = carousel.querySelector('.slider');
    if (!slider) return;

    carousel.dataset.rgFeaturedCenteredLoopBound = 'true';

    slider.addEventListener('scroll', function () {
      requestAnimationFrame(function () {
        normalizeInfiniteScroll(carousel);
      });
    });
  }

  function bindCloneImageLoading(carousel) {
    if (carousel.dataset.rgFeaturedCenteredCloneImagesBound === 'true') return;

    var slider = carousel.querySelector('.slider');
    var cloneImages = carousel.querySelectorAll('[data-rg-featured-centered-clone] img[data-rg-featured-clone-src], [data-rg-featured-centered-clone] img[data-rg-featured-clone-srcset]');
    if (!slider || cloneImages.length === 0) return;

    carousel.dataset.rgFeaturedCenteredCloneImagesBound = 'true';

    INTERACTION_EVENTS.forEach(function (eventName) {
      carousel.addEventListener(eventName, function () {
        restoreCloneImages(carousel);
      }, { passive: true, once: true });
    });

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        restoreCloneImage(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      root: slider,
      rootMargin: '0px 800px'
    });

    cloneImages.forEach(function (image) {
      observer.observe(image);
    });
  }

  function centerCarousel(carousel) {
    if (carousel.dataset.rgFeaturedCenteredReady === 'true') return;
    if (carousel.dataset.rgFeaturedCenteredCentering === 'true') return;
    carousel.dataset.rgFeaturedCenteredCentering = 'true';

    afterLayout(function () {
      carousel.dataset.rgFeaturedCenteredCentering = 'false';
      if (!ensureCarouselReady(carousel)) return;
      if (!setupInfiniteLoop(carousel)) return;
      bindInfiniteScroll(carousel);
      bindCloneImageLoading(carousel);

      var slider = carousel.querySelector('.slider');
      var target = carousel.querySelector('[data-rg-featured-centered-target]');
      var scrollLeft = getCenteredScrollLeft(slider, target);

      withoutSmoothScroll(slider, function () {
        slider.scrollLeft = scrollLeft;
        slider.scrollTo({ left: scrollLeft, behavior: 'auto' });
      });
      carousel.dataset.rgFeaturedCenteredReady = 'true';

      updateCarouselState(carousel, slider);
    });
  }

  function centerCarouselWithRetries(carousel) {
    centerCarousel(carousel);
    [80, 250, 700].forEach(function (delay) {
      setTimeout(function () {
        if (carousel.dataset.rgFeaturedCenteredReady === 'true') return;
        centerCarousel(carousel);
      }, delay);
    });
  }

  function bindImageLoading(carousel) {
    if (carousel.dataset.rgFeaturedCenteredImageBound === 'true') return;
    carousel.dataset.rgFeaturedCenteredImageBound = 'true';

    INTERACTION_EVENTS.forEach(function (eventName) {
      carousel.addEventListener(eventName, function () {
        manuallyLoadImages(carousel);
      }, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          manuallyLoadImages(carousel);
          observer.disconnect();
        });
      }, { rootMargin: '600px 0px' });

      observer.observe(carousel);
    } else {
      window.addEventListener('load', function () {
        manuallyLoadImages(carousel);
      }, { once: true });
    }
  }

  function bindCarousel(carousel) {
    if (carousel.dataset.rgFeaturedCenteredBound === 'true') {
      centerCarouselWithRetries(carousel);
      return;
    }

    carousel.dataset.rgFeaturedCenteredBound = 'true';
    centerCarouselWithRetries(carousel);
    bindImageLoading(carousel);

    window.addEventListener('on:debounced-resize', function () {
      if (!document.documentElement.contains(carousel)) return;
      centerCarouselWithRetries(carousel);
    });
  }

  function bindAll() {
    getCenteredCarousels().forEach(bindCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll, { once: true });
  } else {
    bindAll();
  }

  window.addEventListener('load', bindAll, { once: true });

  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('carousel-slider').then(bindAll);
  }

  document.addEventListener('shopify:section:load', bindAll);
})();
